import { BaseButtonVariants } from 'core/components/button/BaseButtonVariants.ts';

export const BaseButtonConfig = {
	baseButtonVariantTypes: [
		BaseButtonVariants.TEXT,
		BaseButtonVariants.CONTAINED,
		BaseButtonVariants.OUTLINED,
	],
	defaultVariantType: BaseButtonVariants.TEXT,
};
